import React from 'react';

import OtoCountDown from '../common/OtoCountDown';
import { differenceInHours, differenceInMinutes } from 'date-fns';

const storageKey = 'special-offer-1-end-date'

export default class SpecialOfferTimer extends React.Component {
  state = { finishDate: null }

  componentDidMount() {
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    const savedDate = localStorage.getItem(storageKey);
    if (savedDate) {
      this.setState({ finishDate: new Date(savedDate) });
    } else {
      localStorage.setItem(storageKey, tomorrow);
      this.setState({ finishDate: tomorrow });
    }

    this.interval = setInterval(() => this.forceUpdate(), 10 * 1000);
    setTimeout(() => this.forceUpdate(), 2000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  static getHrsText(hrs) {
    if (hrs % 10 > 4) {
      return 'godziny';
    }
    if (hrs > 1) {
      return 'godziny';
    }
    return 'godzina';
  }

  static getMinsText(mins) {
    if (mins % 10 > 4) {
      return 'minut';
    }
    if (mins > 1) {
      return 'minuty';
    }
    return 'minuta';
  }

  render() {
    if (!this.state.finishDate) {
      return null;
    }
    
    const diffInHours = differenceInHours(this.state.finishDate, new Date());
    const diffInMins = differenceInMinutes(this.state.finishDate, new Date());
    
    if (diffInHours <= 0 && diffInMins <= 0) {
      return null;
    }

    return <>
      <h4 className="mt-5">Oferta promocyjna ważna przez:</h4>
      <div className="row">
        <OtoCountDown value={diffInHours} text={SpecialOfferTimer.getHrsText(cd.hours)} />
        <OtoCountDown value={diffInMins % 60} text={SpecialOfferTimer.getMinsText(cd.minutes)} />
      </div>
    </>
  }
}